var pug = require("!../../../../../aan/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (frames, prefix) {var classes = {
    graphic: 'thumbnail',
    table: 'thumbnail',
    media: 'thumbnail'
};
var icons = {
    table: 'icon-tables',
    media: 'icon-digital-object'
};
var renderOverlay = {
    graphic: true,
    table: false,
    media: false
};

pug_mixins["renderThumbnails"] = pug_interp = function(key, root, overlay){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes([classes[key]], [true]), false, true)) + "\u003E";
switch (key){
case 'graphic':
pug_html = pug_html + (null == (pug_interp = root.modifiedContent) ? "" : pug_interp);
  break;
case 'table':
pug_html = pug_html + "\u003Ci" + (pug.attr("class", pug.classes([icons[key]], [true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003C\u002Fi\u003E";
  break;
case 'media':
pug_html = pug_html + "\u003Ci" + (pug.attr("class", pug.classes([icons[key]], [true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003C\u002Fi\u003E";
  break;
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
if ((overlay && renderOverlay[key])) {
pug_html = pug_html + "\u003Cspan class=\"overlay\"\u003E\u003Cspan\u003E" + (null == (pug_interp = overlay) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
};
// iterate frames
;(function(){
  var $$obj = frames;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var frame = $$obj[index];
var root = frame.multiFigure ? frame.multiFigure[0] : frame;
const ariaLabel = frame.title ? 'View ' + frame.title : 'View figure ' + (1 + index);
pug_html = pug_html + "\u003Cbutton" + (" class=\"figures-group-frame\""+pug.attr("aria-label", ariaLabel, true, true)+" type=\"button\" role=\"tab\" aria-selected=\"false\""+pug.attr("aria-controls", prefix+'-'+frame.id, true, true)) + "\u003E";
pug_mixins["renderThumbnails"](frame.type, root, false);
if ((frame.title)) {
pug_html = pug_html + "\u003Cspan class=\"title\" aria-hidden=\"true\"\u003E" + (null == (pug_interp = frame.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
else
if ((frame.caption)) {
pug_html = pug_html + "\u003Cspan class=\"title\" aria-hidden=\"true\"\u003E" + (null == (pug_interp = frame.caption) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fbutton\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var frame = $$obj[index];
var root = frame.multiFigure ? frame.multiFigure[0] : frame;
const ariaLabel = frame.title ? 'View ' + frame.title : 'View figure ' + (1 + index);
pug_html = pug_html + "\u003Cbutton" + (" class=\"figures-group-frame\""+pug.attr("aria-label", ariaLabel, true, true)+" type=\"button\" role=\"tab\" aria-selected=\"false\""+pug.attr("aria-controls", prefix+'-'+frame.id, true, true)) + "\u003E";
pug_mixins["renderThumbnails"](frame.type, root, false);
if ((frame.title)) {
pug_html = pug_html + "\u003Cspan class=\"title\" aria-hidden=\"true\"\u003E" + (null == (pug_interp = frame.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
else
if ((frame.caption)) {
pug_html = pug_html + "\u003Cspan class=\"title\" aria-hidden=\"true\"\u003E" + (null == (pug_interp = frame.caption) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fbutton\u003E";
    }
  }
}).call(this);
}.call(this,"frames" in locals_for_with?locals_for_with.frames:typeof frames!=="undefined"?frames:undefined,"prefix" in locals_for_with?locals_for_with.prefix:typeof prefix!=="undefined"?prefix:undefined));;return pug_html;};
module.exports = template;